import { render, staticRenderFns } from "./VacationSettingsForm.vue?vue&type=template&id=0aac674f"
import script from "./VacationSettingsForm.vue?vue&type=script&lang=js"
export * from "./VacationSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./VacationSettingsForm.vue?vue&type=style&index=0&id=0aac674f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports